import React from "react";
import Animation from "public/lotties/new-spinner.json";
import styled from "styled-components";
import LottieControl from ".";

const PageWrapper = styled.div`
  display: flex;
  width: 100%;
  flex: 1 0 auto;
  align-items: center;
  justify-content: center;
`;

const LottieWrapper = styled.div`
  padding: 4rem;
`;

const LoadingSpinner = () => {
  return (
    <PageWrapper>
      <LottieWrapper>
        <LottieControl animation={Animation} />
      </LottieWrapper>
    </PageWrapper>
  );
};

export default LoadingSpinner;
